import { BROADCAST_DRAG_SOURCE } from 'actions/Types';

const initialState = false;

export default (state = initialState, action) => {
  if (action.type === BROADCAST_DRAG_SOURCE) {
    return action.payload;
  }

  return state;
};
